import { useState } from 'react';
import { Grid } from '@mui/material';
import { CategoryDetails } from 'src/models/Category';
import AllAdminUsersTable from './AllAdminUsersTable';
import AppPage from 'src/components/AppPage';

const AdminUsers = () => {
  const [AllCategories, setAllCategories] = useState([] as CategoryDetails[]);

  return (
    <AppPage
      title="Admin — Users"
      heading="Admin Users"
      description="Manage administrator accounts, roles, and access across LumaPOS."
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12}>
          <AllAdminUsersTable
            AllCategories={AllCategories}
            setAllCategories={setAllCategories}
          />
        </Grid>
      </Grid>
    </AppPage>
  );
};

export default AdminUsers;
